import React from 'react';
import PersonalDetails from "~/Pages/RsvpPreview/PersonalDetails";
import SpecialRequirements from "~/Pages/RsvpPreview/SpecialRequirements";
import HotelRooms from "~/Pages/RsvpPreview/HotelRooms";
import Travel from '~/Pages/RsvpPreview/Travel';
import Emergency from '~/Pages/RsvpPreview/Emergency';
import Documents from '~/Pages/RsvpPreview/Documents';
import AdminEditPersonalDetails from './AdminEditPersonalDetails';
import AdminEditSpecialRequirements from './AdminEditSpecialRequirements';
import AdminEditHotelRooms from './AdminEditHotelRooms';
import AdminEditTravel from './AdminEditTravel';
import AdminEditEmergencyContact from './AdminEditEmergencyContact';
import AdminEditDocuments from './AdminEditDocuments';

import "~/Pages/RsvpPreview/preview.scss";

const AdminGuestPreview = ({ guest, loadData }) => {
    if (!guest) { return <></>; }

    const steps = guest?.invitation?.package?.steps || false;

    return (
        <div className="rsvp-preview">

            <div className="row mt-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h2>Personal Details</h2>
                        <AdminEditPersonalDetails
                            onChange={loadData}
                            className="btn btn-secondary btn-icon btn-sm mr-3"
                            guest={guest}
                        />
                    </div>
                    <PersonalDetails guest={guest} />
                </div>
            </div>

            {steps.special_requirements &&
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2>Special Requirements</h2>
                            <AdminEditSpecialRequirements
                                className="btn btn-secondary btn-icon btn-sm mr-3"
                                guest={guest}
                                onChange={loadData}
                            />
                        </div>
                        <SpecialRequirements guest={guest} />
                    </div>
                </div>
            }

            {(steps.hotel_rooms && guest.main) &&
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2>Hotel Rooms</h2>
                            <AdminEditHotelRooms
                                className="btn btn-secondary btn-icon btn-sm mr-3"
                                guest={guest}
                                onChange={loadData}
                            />
                        </div>
                        <HotelRooms guest={guest} />
                    </div>
                </div>
            }

            {steps.travel &&
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2>Flights & Travel</h2>
                            <AdminEditTravel
                                className="btn btn-secondary btn-icon btn-sm mr-3"
                                guest={guest}
                                onChange={loadData}
                            />
                        </div>
                        <Travel guest={guest} />
                    </div>
                </div>
            }

            {steps.emergency_contact &&
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2>Emergency Contact</h2>
                            <AdminEditEmergencyContact
                                className="btn btn-secondary btn-icon btn-sm mr-3"
                                guest={guest}
                                onChange={loadData}
                            />
                        </div>
                        <Emergency guest={guest} />
                    </div>
                </div>
            }

            {steps.documents &&
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2>Supporting Documents</h2>
                            <AdminEditDocuments
                                className="btn btn-secondary btn-icon btn-sm mr-3"
                                guest={guest}
                                onChange={loadData}
                            />
                        </div>
                        <Documents guest={guest} />
                    </div>
                </div>
            }

        </div>
    );
}

export default AdminGuestPreview;
